import { h } from 'preact'
import { StateProvider } from '../state/Quiz.context'
import { reducers } from '../state/reducers/Root.reducer'
import { Previous } from './Previous'
import { Next } from './Next'
import { Wizard } from './Wizard'
import quizQuestions from '../questions.json'
import quizResults from '../results.json'
import { QuizAdapter } from '../adapters/quiz.adapter'
import { ResultsAdapter } from '../adapters/results.adapter'

/** @jsx h */

export const App = ({
  title,
  description,
  questions,
  answers,
  results,
  resulted_title,
  resulted_description
}) => {
  const firstQuestion = `${questions[0].question}${questions[0].position}`
  const initialState = {
    wizard: {
      title,
      description,
      resulted_title,
      resulted_description,
      current: firstQuestion,
      previous: '',
      next: '',
      history: { [firstQuestion]: firstQuestion }
    },
    quiz: { ...QuizAdapter(questions, answers, results) },
    results: { ...ResultsAdapter(results) }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducers}>
      <div className="u-flex c-quiz__container">
        <Wizard />
      </div>
    </StateProvider>
  )
}



// WEBPACK FOOTER //
// ./src/js/quiz/components/App.jsx